import * as THREE from "three";
import parameterValues from "./parameterValues";
import { app } from "./context";

export function setupRenderTargets() {
  if (app.renderTargets?.length) {
    for (const rt of app.renderTargets) {
      rt.dispose();
    }
  }

  app.renderTargets = [];
  for (let i = 0; i < 2; i++) {
    app.renderTargets.push(
      new THREE.WebGLRenderTarget(
        parameterValues.canvas.width,
        parameterValues.canvas.height,
        {
          minFilter: parameterValues.useSmoothing
            ? THREE.LinearFilter
            : THREE.NearestFilter,
          magFilter: parameterValues.useSmoothing
            ? THREE.LinearFilter
            : THREE.NearestFilter,
          format: THREE.RGBAFormat,
          type: THREE.FloatType,
        },
      ),
    );
  }
}
